export const DEFAULT = '/';
export const HOME = '/home';
export const HOME_CMS = '/home-cms';
export const LANDING = '/landing';
export const LOGIN = '/login';
export const OPEN_BETS = '/open-bets';
export const SETTLED_BETS = '/settled-bets';
export const SETTINGS = '/settings';
export const CHANGE_NUMBER = '/change-number';
export const LOST_CARD = '/lostCard';
export const ADD_BETSLIP = '/add-betslip';
export const SUPPORT = '/support';
export const COOKIE = '/cookie';
export const TERMS = '/terms';
export const OFFERS = '/offers';
export const REWARDS = '/rewards';
export const RESPONSIBLE_GAMBLING = '/responsible-gambling';
export const NOT_FOUND = '/404';
export const LINK_SUCCESS = '/link-success';
export const WHO_REGISTER_SUCCESS = '/who-register-success';
export const WHO_LOGIN_SUCCESS = '/who-login-success';
export const OMNI_SET_PIN = '/omni-set-pin';
export const OMNI_WITHDRAW = '/omni-withdraw';
export const FREE_BETS = '/free-bets';
export const OMNI_TRANSFER = '/omni-transfer';
export const LOGIN_CONSENTS = '/consents';
export const MARKETING_PREFERENCES = '/marketing-preferences';
export const ENTER_SHOP_ID = '/lbo';
export const ACTIVATE = '/activate';
export const PRIVACY = '/privacy';
export const BETTING_BUDDY = '/betting-buddy';
export const NEW_SLIP = '/new-slip';
export const SAVED_SLIPS = '/slips';
export const LIVE_SCORES = '/scores';
export const LINK_ACCOUNT = '/link-account';
export const REGISTER = '/register';
